module.exports = "/fonts/NeoSansStd-Light.ttf?4558b57f8958e4783fc4c68f10720163";